export function setToken(value) {
  return window.sessionStorage.setItem("TOKEN", value);
}
export function getToken() {
  return window.sessionStorage.getItem("TOKEN");
}
export function clearToken() {
  return window.sessionStorage.setItem("TOKEN", "");
}
export function setStudentID(value) {
  return window.sessionStorage.setItem("studentID", value);
}
export function getStudentID() {
  return window.sessionStorage.getItem("studentID");
}
export function setInfo(value) {
  return window.localStorage.setItem("Info", value);
}
export function getInfo() {
  return window.localStorage.getItem("Info");
}
export function setUserInfo(value) {
  return window.localStorage.setItem("userInfo", value);
}
export function getUserInfo() {
  return window.localStorage.getItem("userInfo");
}
// export function setTime(value) {
//   return window.localStorage.setItem("submitTime", value);
// }
// export function getTime() {
//   return window.localStorage.getItem("submitTime");
// }
